import React from 'react'
import './ContactUsInfo.css'

const ContactUsInfo = () => {
  return (
    <div className='contact-us-info-container'>
        <div className="hl-0"></div>
        <div className="hl-1"></div>
        <div className="hl-2"></div>
        <div className="hl-3"></div>
        <div className="contact-us-info-wrapper">
            <div className="left-info-container"></div>
            <div className="right-info-container">
                <div className="phone-heading">PHONE</div>
                <div className="contact">+91 9888211088</div>
                <div className="contact">+91 9417565591</div>
                <div className="email-heading">EMAIL</div>
                <div className="email-addr">chawla_strdesignengg@yahoo.co.in</div>
                <div className="address-heading">ADDRESS</div>
                <div className="address">#956 Sector 4, Panchkula, Haryana, 134112</div>
                <div className="contact-info-title">CONTACTS</div>
            </div>
        </div>
    </div>
  )
}

export default ContactUsInfo
